module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"all":"Voir tout"},"en":{"all":"See all"},"de":{"all":"Alles sehen"},"es":{"all":"Me interesa"},"it":{"all":"Scopri"},"nl":{"all":"Alles bekijken"},"pt":{"all":"Ver tudo"}}')
  delete Component.options._Ctor
}
